import classnames from 'classnames';

import { normalizeTestId } from '../../utils';

import { DefaultLink, LinkIdentifier } from './defaultMenuLinks';
import { Link } from './Header';

interface MenuLinksProps {
  links: Array<Link | DefaultLink>;
  /**
   * Test ID for automated testing
   */
  'data-testid'?: string;
}

/**
 * The primary list of menu links. This ensures a consistent styling
 * across header variations. On the homepage, this list is displayed
 * horizontally on desktop. In other versions, this list is visible
 * when the "Menu" button is toggled and displayed as a stacked list.
 */
const MenuLinks = (props: MenuLinksProps) => (
  <nav
    aria-label='Menu navigation'
    data-testid={props['data-testid'] ?? 'menu-links'}>
    <ul
      className='hc-c-menu__links ds-c-list ds-c-list--bare'
      data-testid={`${props['data-testid'] ?? 'menu-links'}-list`}
      role='list'>
      {props.links.map(function (link) {
        const isLoginLogoutLink =
          (link as DefaultLink).identifier === LinkIdentifier.LOGIN ||
          (link as DefaultLink).identifier === LinkIdentifier.LOGOUT;
        function onClick(event) {
          if (link.onClick) {
            return link.onClick(event);
          }
        }

        return (
          <li
            key={link.href}
            className={`ds-u-margin--0 ${isLoginLogoutLink ? 'ds-u-border-top--1' : ''}`}
            data-testid={`${props['data-testid'] ?? 'menu-links'}-item-${normalizeTestId(link.href)}`}>
            <a
              aria-label={link.ariaLabel}
              className={classnames('hc-c-menu__link', link.className)}
              data-testid={`${props['data-testid'] ?? 'menu-links'}-link-${normalizeTestId(link.href)}`}
              href={link.href}
              onClick={onClick}>
              {link.label}
            </a>
          </li>
        );
      })}
    </ul>
  </nav>
);

export default MenuLinks;
